module.exports = __webpack_public_path__ + "media/images/photo14-e20caf8c50918ce496d487d1ca4a2d8a.png";